import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
import { SEO } from '../../components/SEO';
export const AutoWrappenPage = () => {
  return <main data-id="element-825" data-mp="3vx6tli5qzd51">
      <SEO title="Auto Wrappen Almere | Premium Car Wrapping | BKCustoms" description="Professioneel auto wrappen in Almere vanaf €1.250. Transformeer uw auto met premium vinyl wraps en bescherm de originele lak. BKCustoms auto styling service." canonical="/diensten/autowrappen" data-id="element-826" data-mp="3vwx37tgsj3yt" />
      {/* Header Banner */}
      <div className="relative bg-[#0a0a0a] py-28" data-id="element-827" data-mp="3hwmbko7nplcl">
        <div className="absolute inset-0 overflow-hidden" data-id="element-828" data-mp="3cyb3ahx0fiwh">
          <div className="absolute inset-0 bg-black/80 z-10" data-id="element-829" data-mp="3d0x9oe85zsd4"></div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vPa5oULwHDcYzvNDCacQ1D/how-long-does-vinyl-wrap-last-1200x800-1-768x512.jpg" alt="Auto Wrappen in Almere" className="w-full h-full object-cover object-center" data-id="element-830" data-mp="38ykbqbznsyqw" />
        </div>
        <div className="relative z-20 max-w-7xl mx-auto px-6 lg:px-8 text-center" data-id="element-831" data-mp="1ipoow9q7svvk">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-832" data-mp="1nq31m52rgtzx">
            <span className="text-[#D6281F]" data-id="element-833" data-mp="19q1qzxwp2879">Auto Wrappen Almere</span> -
            Transformeer uw auto
          </h1>
          <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-834" data-mp="1dr3symhzwycx">
            Professioneel auto wrappen in Almere. Transformeer uw auto met
            premium wraps en bescherm de originele lak met onze vakkundige
            wrapping service.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mt-8" data-id="element-835" data-mp="26if3yrtezva2">
            <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide inline-flex items-center justify-center" data-id="element-836" data-mp="1sonpr64qnn80">
              <span className="mr-2" data-id="element-837" data-mp="2p7by8votansa">Direct afspraak maken</span>
              <ArrowRightIcon size={16} data-id="element-838" data-mp="2p8n0us6itpht" />
            </Link>
            <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10 inline-flex items-center justify-center" data-id="element-839" data-mp="2z1hi7v0tfvr8">
              Offerte aanvragen
            </Link>
          </div>
        </div>
      </div>
      {/* Service Description Section */}
      <section className="bg-[#0a0a0a] py-20" data-id="element-840" data-mp="2g4q1ntcnruqv">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-841" data-mp="2bd7zx32t9q4u">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-842" data-mp="2bcerzys48ul4">
            {/* Image Section */}
            <div className="w-full lg:w-1/2" data-id="element-843" data-mp="27buwezn6xz13">
              <div className="relative" data-id="element-844" data-mp="22d1odmqob08b">
                <div className="absolute -inset-4 bg-gradient-to-tr from-[#D6281F] via-[#FF6B00] to-[#FFD500] opacity-30 blur-lg rounded-lg" data-id="element-845" data-mp="22ectpqzrog1j"></div>
                <div className="relative overflow-hidden rounded-lg border border-white/10 shadow-2xl" data-id="element-846" data-mp="1seluxd46bevn">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vPa5oULwHDcYzvNDCacQ1D/how-long-does-vinyl-wrap-last-1200x800-1-768x512.jpg" alt="Auto wrappen voorbeeld in Almere" className="w-full h-auto object-cover" data-id="element-847" data-mp="1iax57f1iv3aq" />
                </div>
              </div>
            </div>
            {/* Content Section */}
            <div className="w-full lg:w-1/2" data-id="element-848" data-mp="zkfne5i89s45">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-849" data-mp="zlqsc8net5wu">
                Premium Car Wrapping in Almere
              </h2>
              <p className="text-white/80 text-lg mb-6 leading-relaxed" data-id="element-850" data-mp="19hk3bnlhcrci">
                Bij BKCustoms in Almere bieden we professionele car wrapping
                diensten met hoogwaardige vinylfolies die uw auto een complete
                transformatie geven. Of u nu op zoek bent naar een
                kleurverandering, matte afwerking, of een uniek ontwerp, wij
                maken het mogelijk.
              </p>
              <p className="text-white/80 text-lg mb-8 leading-relaxed" data-id="element-851" data-mp="2nighdphn1try">
                Naast het esthetische aspect biedt een carwrap ook bescherming
                voor uw originele lak tegen steenslag, UV-straling en lichte
                krassen, waardoor de waarde van uw auto behouden blijft.
              </p>
              <div className="space-y-4 mb-8" data-id="element-852" data-mp="2sfgng0ehmwj2">
                <div className="flex items-center" data-id="element-853" data-mp="367n3znljz5j1">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-854" data-mp="366d3krr89l98">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-855" data-mp="325t5nlytydm1" />
                  </div>
                  <span className="text-white/90" data-id="element-856" data-mp="3g5b12k6msp4d">
                    Premium vinylfolies met lange levensduur
                  </span>
                </div>
                <div className="flex items-center" data-id="element-857" data-mp="1lsbe25zx8sn2">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-858" data-mp="1lt4d0ksn2dun">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-859" data-mp="1gu1i3t6dho0e" />
                  </div>
                  <span className="text-white/90" data-id="element-860" data-mp="3sg20w7jjb605">
                    Bescherming van originele lak
                  </span>
                </div>
                <div className="flex items-center" data-id="element-861" data-mp="19iowp1ypa09">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-862" data-mp="3irbmfw7b5pk9">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-863" data-mp="3npvaq39djdfs" />
                  </div>
                  <span className="text-white/90" data-id="element-864" data-mp="3nniohdwl2gwx">
                    Uitgebreide kleur- en afwerkingsopties
                  </span>
                </div>
                <div className="flex items-center" data-id="element-865" data-mp="3epyhdoc1hqee">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-866" data-mp="2zs6472tyte3d">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-867" data-mp="2zu0t0s8cxqcq" />
                  </div>
                  <span className="text-white/90" data-id="element-868" data-mp="34t3ktazbu02r">
                    Professionele installatie door ervaren specialisten in
                    Almere
                  </span>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-869" data-mp="12x9xy1wtp2yn">
                <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide inline-flex items-center justify-center" data-id="element-870" data-mp="11k1vepp54zqw">
                  <span className="mr-2" data-id="element-871" data-mp="njhfq2eivk1m">Afspraak maken</span>
                  <ArrowRightIcon size={16} data-id="element-872" data-mp="1k8ysf1bxa6ct" />
                </Link>
                <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10 inline-flex items-center justify-center" data-id="element-873" data-mp="1k8gjp582pzo0">
                  Offerte aanvragen
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Options Section */}
      <section className="bg-[#0f0f0f] py-20" data-id="element-874" data-mp="1y8zps6szavnj">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-875" data-mp="1y76n12lhkvkt">
          <div className="text-center mb-16" data-id="element-876" data-mp="3gw0ylj92118w">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-877" data-mp="3gxc2rk6ewb0j">
              Onze <span className="text-[#D6281F]" data-id="element-878" data-mp="3lvdnsaneeken">Wrapping Opties</span> in
              Almere
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-879" data-mp="3pumibhq9imb9">
              Bij BKCustoms in Almere bieden we twee hoogwaardige wrapping
              oplossingen: Vinyl wrapping en PPF (Paint Protection Film).
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-880" data-mp="8nsq2bvswfk4">
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-881" data-mp="8ly18mhes3ar">
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-882" data-mp="dfapgvi6e82z">
                Vinyl Wrapping
              </h3>
              <p className="text-white/80 mb-6" data-id="element-883" data-mp="higtdwhtfn6a">
                Vinyl wraps zijn perfect voor het veranderen van de kleur en
                uitstraling van uw auto. Beschikbaar in een breed scala aan
                kleuren en afwerkingen: glanzend, mat, satijn, metallic, chroom
                en zelfs kleurveranderende opties. Vinyl biedt een goede
                bescherming tegen lichte krassen en UV-straling, met een
                levensduur van 5-7 jaar bij goed onderhoud.
              </p>
              <ul className="space-y-2 mb-6" data-id="element-884" data-mp="b9ysuhu7ilet">
                <li className="flex items-center text-white/80" data-id="element-885" data-mp="7a7yk45h1n5j">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-886" data-mp="3fqau5bjb7ldi" />
                  Volledige kleurverandering
                </li>
                <li className="flex items-center text-white/80" data-id="element-887" data-mp="3as9c8txmds3m">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-888" data-mp="3oil7v2tey8zi" />
                  Diverse afwerkingen (mat, glanzend, satijn)
                </li>
                <li className="flex items-center text-white/80" data-id="element-889" data-mp="3jqblfwribr1z">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-890" data-mp="2w1ikflw12t0i" />
                  Gedeeltelijke wraps en accenten mogelijk
                </li>
                <li className="flex items-center text-white/80" data-id="element-891" data-mp="2rym6w9lchn3f">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-892" data-mp="2hw0468cwatt5" />
                  Bescherming tegen lichte beschadigingen
                </li>
              </ul>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-893" data-mp="27zdmfsfv8ivc">
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-894" data-mp="2cx5mxauktdb5">
                PPF (Paint Protection Film)
              </h3>
              <p className="text-white/80 mb-6" data-id="element-895" data-mp="30oaz9g1b5ngp">
                PPF is een transparante of licht getinte premium
                beschermingslaag die maximale bescherming biedt tegen steenslag,
                krassen, insecten en weersinvloeden. Deze zelfhelende film is
                dikker dan vinyl en speciaal ontworpen voor langdurige
                bescherming, met een levensduur tot 10 jaar. Ideaal voor het
                behoud van uw originele lak of als beschermlaag over vinyl
                wraps.
              </p>
              <ul className="space-y-2 mb-6" data-id="element-896" data-mp="1k6x1na4qucsc">
                <li className="flex items-center text-white/80" data-id="element-897" data-mp="1u22zpvsxsvhe">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-898" data-mp="1z1fvx75p7ewn" />
                  Superieure bescherming tegen steenslag
                </li>
                <li className="flex items-center text-white/80" data-id="element-899" data-mp="1kbrtg2ls6a7c">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-900" data-mp="1pb4gancnjh9x" />
                  Zelfhelende eigenschappen
                </li>
                <li className="flex items-center text-white/80" data-id="element-901" data-mp="1bb1yt289apv7">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-902" data-mp="1gbhei0g0g9gc" />
                  Transparant of licht getint
                </li>
                <li className="flex items-center text-white/80" data-id="element-903" data-mp="11f8id7rf2c85">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-904" data-mp="16byw3ofr0vqe" />
                  Langere levensduur dan vinyl
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Process Section */}
      <section className="bg-[#0a0a0a] py-20" data-id="element-905" data-mp="30op1p3fhbtdm">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-906" data-mp="p2o95xcimx0o">
          <div className="text-center mb-16" data-id="element-907" data-mp="p1d29onrx95c">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-908" data-mp="k54lk6txh7w2">
              Ons <span className="text-[#D6281F]" data-id="element-909" data-mp="yszgltverocb">Proces</span> in Almere
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-910" data-mp="u2j0u3447qms">
              Bij BKCustoms in Almere volgen we een zorgvuldig proces om de
              hoogste kwaliteit car wrapping te garanderen.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-911" data-mp="13ranpwubjkqu">
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg relative" data-id="element-912" data-mp="1hrv6it08hgkc">
              <div className="absolute -top-4 -left-4 bg-[#D6281F] w-8 h-8 rounded-full flex items-center justify-center text-white font-bold" data-id="element-913" data-mp="1ct0q1xpqo43e">
                1
              </div>
              <h3 className="text-xl font-bold text-white mb-4 mt-2" data-id="element-914" data-mp="3jlkphk4u9eo6">
                Consultatie
              </h3>
              <p className="text-white/80" data-id="element-915" data-mp="1ih8r27neu38j">
                We bespreken uw wensen en adviseren over de beste opties voor uw
                voertuig, inclusief kleur, afwerking en materiaal.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg relative" data-id="element-916" data-mp="1rhfa091vnvf3">
              <div className="absolute -top-4 -left-4 bg-[#D6281F] w-8 h-8 rounded-full flex items-center justify-center text-white font-bold" data-id="element-917" data-mp="1wgrvoqh0iwg3">
                2
              </div>
              <h3 className="text-xl font-bold text-white mb-4 mt-2" data-id="element-918" data-mp="26f7rh6qzitvx">
                Voorbereiding
              </h3>
              <p className="text-white/80" data-id="element-919" data-mp="2b5ecyxq79y9y">
                Uw auto wordt grondig gereinigd en ontvet om een perfecte
                hechting van de vinylfolie te garanderen.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg relative" data-id="element-920" data-mp="2k7dvxvkrzcfj">
              <div className="absolute -top-4 -left-4 bg-[#D6281F] w-8 h-8 rounded-full flex items-center justify-center text-white font-bold" data-id="element-921" data-mp="2p55z5lqvekz1">
                3
              </div>
              <h3 className="text-xl font-bold text-white mb-4 mt-2" data-id="element-922" data-mp="2uaj6ult2pfqn">
                Installatie
              </h3>
              <p className="text-white/80" data-id="element-923" data-mp="2pawtmcd8vzhu">
                Onze ervaren specialisten in Almere brengen de vinylfolie
                zorgvuldig aan, met aandacht voor elk detail en perfecte
                afwerking rond randen en hoeken.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg relative" data-id="element-924" data-mp="3d10w2gep5t79">
              <div className="absolute -top-4 -left-4 bg-[#D6281F] w-8 h-8 rounded-full flex items-center justify-center text-white font-bold" data-id="element-925" data-mp="3d3daijl8xlfk">
                4
              </div>
              <h3 className="text-xl font-bold text-white mb-4 mt-2" data-id="element-926" data-mp="348gub733z8i7">
                Afwerking
              </h3>
              <p className="text-white/80" data-id="element-927" data-mp="4n219i3godvc">
                Na installatie wordt uw auto geïnspecteerd op perfectie en
                ontvangt u advies over onderhoud om de levensduur van uw wrap te
                maximaliseren.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="bg-[#0a0a0a] py-16 border-t border-[#222]" data-id="element-928" data-mp="37hp108gyx5og">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center" data-id="element-929" data-mp="37jjmpp02d1tl">
          <h2 className="text-3xl font-bold text-white mb-6" data-id="element-930" data-mp="3bjakico0ci7m">
            Klaar voor een nieuwe look met auto wrappen in Almere?
          </h2>
          <p className="text-white/80 mb-8" data-id="element-931" data-mp="81sfeczmdpaw">
            Neem contact met ons op voor een persoonlijk advies of maak direct
            een afspraak voor jouw auto bij BKCustoms in Almere.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-932" data-mp="3uhehk8qmeqt2">
            <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide" data-id="element-933" data-mp="3ufa8lcdv71lx">
              Afspraak maken
            </Link>
            <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10" data-id="element-934" data-mp="2bhnm99c587vm">
              Contact opnemen
            </Link>
          </div>
        </div>
      </section>
    </main>;
};